import { drilldownData, ModuleFields } from "@utils/drilldownData";

export const fields: any = {
  pageContent: drilldownData["pageContent"].map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      loadOptions,
      options,
      usedFileType,
    })
  ),
  pageHeading: drilldownData["pageHeading"].map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      loadOptions,
      options,
      usedFileType,
    })
  ),
};